/**
 * Platform detection utilities for cross-platform haptic feedback
 */

export const detectiOS = (): boolean => {
  if (typeof window === 'undefined') return false;

  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

export const detectAndroid = (): boolean => {
  if (typeof window === 'undefined') return false;

  return /Android/i.test(navigator.userAgent);
};

export const detectMobile = (): boolean => {
  if (typeof window === 'undefined') return false;

  return (
    detectiOS() ||
    detectAndroid() ||
    /Windows Phone|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent)
  );
};

export const detectPWA = (): boolean => {
  if (typeof window === 'undefined') return false;

  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as { standalone?: boolean }).standalone === true ||
    document.referrer.includes('android-app://')
  );
};

export const hasVibrationSupport = (): boolean => {
  if (typeof window === 'undefined') return false;

  return 'vibrate' in navigator;
};

export const getPlatformInfo = () => ({
  isIOS: detectiOS(),
  isAndroid: detectAndroid(),
  isMobile: detectMobile(),
  isPWA: detectPWA(),
  hasVibration: hasVibrationSupport(),
  userAgent: typeof window !== 'undefined' ? navigator.userAgent : '',
});

export type PlatformInfo = ReturnType<typeof getPlatformInfo>;
